import { render, staticRenderFns } from "./sk-radio.vue?vue&type=template&id=9b4d92ba&scoped=true&"
import script from "./sk-radio.vue?vue&type=script&lang=js&"
export * from "./sk-radio.vue?vue&type=script&lang=js&"
import style0 from "./sk-radio.vue?vue&type=style&index=0&id=9b4d92ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4d92ba",
  null
  
)

export default component.exports